/**
 * lgk-outils-hub.js — Outils interactifs LeGeekShop
 */
(function () {
  'use strict';

  const VAT = 0.2;
  const FREE_SHIP = 75;
  const FX = { USD: 1.08, GBP: 0.86, CHF: 0.94 };

  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function bind(root, sel, evt, fn) {
    root.querySelectorAll(sel).forEach((node) => node.addEventListener(evt, fn));
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  const TOOLS = {
    'seo-counter': {
      title: 'Compteur caractères SEO',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Titre SEO <span class="lgk-outil__hint">(idéal ≤ 60 car.)</span>
              <input type="text" data-seo-title placeholder="Ex. Mapping FiveM — MLO & scripts RP">
            </label>
            <div class="lgk-outil__meter" data-title-meter>
              <div class="lgk-outil__meter-bar"><div class="lgk-outil__meter-fill" style="width:0%"></div></div>
              <span data-title-count>0 / 60 caractères</span>
            </div>
            <label>Meta description <span class="lgk-outil__hint">(idéal ≤ 160 car.)</span>
              <textarea data-seo-desc placeholder="Description pour Google…"></textarea>
            </label>
            <div class="lgk-outil__meter" data-desc-meter>
              <div class="lgk-outil__meter-bar"><div class="lgk-outil__meter-fill" style="width:0%"></div></div>
              <span data-desc-count>0 / 160 caractères</span>
            </div>
          </div>`;
      },
      mount(root) {
        const title = root.querySelector('[data-seo-title]');
        const desc = root.querySelector('[data-seo-desc]');
        function update(input, max, countEl, fillEl) {
          const n = input.value.length;
          const pct = Math.min(100, (n / max) * 100);
          countEl.textContent = `${n} / ${max} caractères`;
          fillEl.style.width = `${pct}%`;
          fillEl.classList.toggle('is-over', n > max);
        }
        const titleFill = root.querySelector('[data-title-meter] .lgk-outil__meter-fill');
        const titleCount = root.querySelector('[data-title-count]');
        const descFill = root.querySelector('[data-desc-meter] .lgk-outil__meter-fill');
        const descCount = root.querySelector('[data-desc-count]');
        title.addEventListener('input', () => update(title, 60, titleCount, titleFill));
        desc.addEventListener('input', () => update(desc, 160, descCount, descFill));
      },
    },

    'ttc-ht': {
      title: 'Calculateur TTC ↔ HT',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <div class="lgk-outil__row lgk-outil__row--2">
              <label>Montant HT (€)<input type="number" step="0.01" data-ht placeholder="100"></label>
              <label>Montant TTC (€)<input type="number" step="0.01" data-ttc placeholder="120"></label>
            </div>
            <p class="lgk-outil__hint">TVA France : 20 % — modifiez un champ, l'autre se calcule.</p>
            <div class="lgk-outil__result lgk-outil__result--muted" data-out>TVA : — · TTC : —</div>
          </div>`;
      },
      mount(root) {
        const ht = root.querySelector('[data-ht]');
        const ttc = root.querySelector('[data-ttc]');
        const out = root.querySelector('[data-out]');
        let lock = null;
        function fromHt() {
          if (lock === 'ttc') return;
          lock = 'ht';
          const v = parseFloat(ht.value);
          if (!isNaN(v)) {
            const t = v * (1 + VAT);
            ttc.value = t.toFixed(2);
            out.textContent = `TVA : ${(t - v).toFixed(2)} € · TTC : ${t.toFixed(2)} €`;
          }
          lock = null;
        }
        function fromTtc() {
          if (lock === 'ht') return;
          lock = 'ttc';
          const v = parseFloat(ttc.value);
          if (!isNaN(v)) {
            const h = v / (1 + VAT);
            ht.value = h.toFixed(2);
            out.textContent = `TVA : ${(v - h).toFixed(2)} € · HT : ${h.toFixed(2)} €`;
          }
          lock = null;
        }
        ht.addEventListener('input', fromHt);
        ttc.addEventListener('input', fromTtc);
      },
    },

    'livraison-75': {
      title: 'Simulateur livraison offerte',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Total panier produits physiques (€)
              <input type="number" step="0.01" data-cart value="50" min="0">
            </label>
            <div class="lgk-outil__result" data-out></div>
            <p class="lgk-outil__hint">Livraison offerte dès ${FREE_SHIP} € sur les produits expédiés LeGeekShop.</p>
          </div>`;
      },
      mount(root) {
        const cart = root.querySelector('[data-cart]');
        const out = root.querySelector('[data-out]');
        function run() {
          const v = parseFloat(cart.value) || 0;
          const rest = FREE_SHIP - v;
          if (v >= FREE_SHIP) {
            out.className = 'lgk-outil__result';
            out.textContent = '🎉 Livraison offerte débloquée !';
          } else {
            out.className = 'lgk-outil__result lgk-outil__result--warn';
            out.textContent = `Plus que ${rest.toFixed(2)} € pour la livraison offerte.`;
          }
        }
        cart.addEventListener('input', run);
        run();
      },
    },

    remise: {
      title: 'Calculateur de remise',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <div class="lgk-outil__row lgk-outil__row--2">
              <label>Prix initial (€)<input type="number" step="0.01" data-price value="100"></label>
              <label>Remise (%)<input type="number" step="1" data-pct value="10" min="0" max="100"></label>
            </div>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const price = root.querySelector('[data-price]');
        const pct = root.querySelector('[data-pct]');
        const out = root.querySelector('[data-out]');
        function run() {
          const p = parseFloat(price.value) || 0;
          const r = parseFloat(pct.value) || 0;
          const final = p * (1 - r / 100);
          const saved = p - final;
          out.textContent = `Prix final : ${final.toFixed(2)} € · Économie : ${saved.toFixed(2)} € (${r} %)`;
        }
        price.addEventListener('input', run);
        pct.addEventListener('input', run);
        run();
      },
    },

    bytes: {
      title: 'Convertisseur octets',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Valeur<input type="number" step="any" data-val value="1024"></label>
            <label>Unité source
              <select data-from>
                <option value="0">Octets (B)</option>
                <option value="1">Ko</option>
                <option value="2" selected>Mo</option>
                <option value="3">Go</option>
                <option value="4">To</option>
              </select>
            </label>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const val = root.querySelector('[data-val]');
        const from = root.querySelector('[data-from]');
        const out = root.querySelector('[data-out]');
        const units = ['B', 'Ko', 'Mo', 'Go', 'To'];
        function run() {
          const v = parseFloat(val.value) || 0;
          const exp = parseInt(from.value, 10);
          const bytes = v * Math.pow(1024, exp);
          const lines = units.map((u, i) => {
            const n = bytes / Math.pow(1024, i);
            return `${n.toLocaleString('fr-FR', { maximumFractionDigits: 4 })} ${u}`;
          });
          out.innerHTML = lines.join('<br>');
        }
        val.addEventListener('input', run);
        from.addEventListener('change', run);
        run();
      },
    },

    password: {
      title: 'Générateur de mot de passe',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Longueur<input type="number" data-len value="16" min="8" max="64"></label>
            <label><input type="checkbox" data-sym checked> Symboles (!@#$…)</label>
            <div class="lgk-outil__actions">
              <button type="button" class="lgk-outil__btn" data-gen>Générer</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-copy>Copier</button>
            </div>
            <div class="lgk-outil__result" data-out>—</div>
          </div>`;
      },
      mount(root) {
        const len = root.querySelector('[data-len]');
        const sym = root.querySelector('[data-sym]');
        const out = root.querySelector('[data-out]');
        const base = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        const symbols = '!@#$%&*+-=?';
        function gen() {
          const chars = base + (sym.checked ? symbols : '');
          const arr = new Uint32Array(parseInt(len.value, 10) || 16);
          crypto.getRandomValues(arr);
          let pwd = '';
          for (let i = 0; i < arr.length; i++) pwd += chars[arr[i] % chars.length];
          out.textContent = pwd;
        }
        root.querySelector('[data-gen]').addEventListener('click', gen);
        root.querySelector('[data-copy]').addEventListener('click', () => copyText(out.textContent));
        gen();
      },
    },

    uuid: {
      title: 'Générateur UUID v4',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <div class="lgk-outil__actions">
              <button type="button" class="lgk-outil__btn" data-gen>Générer UUID</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-copy>Copier</button>
            </div>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const out = root.querySelector('[data-out]');
        function gen() {
          out.textContent = crypto.randomUUID();
        }
        root.querySelector('[data-gen]').addEventListener('click', gen);
        root.querySelector('[data-copy]').addEventListener('click', () => copyText(out.textContent));
        gen();
      },
    },

    'word-count': {
      title: 'Compteur de mots',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Texte<textarea data-text placeholder="Collez votre texte…"></textarea></label>
            <div class="lgk-outil__result" data-out>Mots : 0 · Caractères : 0 · Lignes : 0</div>
          </div>`;
      },
      mount(root) {
        const text = root.querySelector('[data-text]');
        const out = root.querySelector('[data-out]');
        text.addEventListener('input', () => {
          const t = text.value;
          const words = t.trim() ? t.trim().split(/\s+/).length : 0;
          out.textContent = `Mots : ${words} · Caractères : ${t.length} · Lignes : ${t.split(/\n/).length}`;
        });
      },
    },

    slug: {
      title: 'Générateur de slug URL',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Titre ou texte<input type="text" data-in placeholder="Mapping Gouvernement FiveM V2"></label>
            <div class="lgk-outil__result" data-out></div>
            <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-copy>Copier le slug</button>
          </div>`;
      },
      mount(root) {
        const input = root.querySelector('[data-in]');
        const out = root.querySelector('[data-out]');
        function slugify(s) {
          return s
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }
        input.addEventListener('input', () => {
          out.textContent = slugify(input.value) || '—';
        });
        root.querySelector('[data-copy]').addEventListener('click', () => copyText(out.textContent));
      },
    },

    base64: {
      title: 'Encodeur / Décodeur Base64',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Texte<textarea data-text placeholder="Texte à encoder ou Base64 à décoder"></textarea></label>
            <div class="lgk-outil__actions">
              <button type="button" class="lgk-outil__btn" data-enc>Encoder</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-dec>Décoder</button>
            </div>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const text = root.querySelector('[data-text]');
        const out = root.querySelector('[data-out]');
        root.querySelector('[data-enc]').addEventListener('click', () => {
          try {
            out.textContent = btoa(unescape(encodeURIComponent(text.value)));
          } catch (e) {
            out.textContent = 'Erreur encodage';
          }
        });
        root.querySelector('[data-dec]').addEventListener('click', () => {
          try {
            out.textContent = decodeURIComponent(escape(atob(text.value.trim())));
          } catch (e) {
            out.textContent = 'Base64 invalide';
          }
        });
      },
    },

    'json-format': {
      title: 'Formateur JSON',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>JSON<textarea data-json placeholder='{"cle":"valeur"}'></textarea></label>
            <button type="button" class="lgk-outil__btn" data-fmt>Formater</button>
            <pre class="lgk-outil__result" data-out style="white-space:pre-wrap;margin:0"></pre>
          </div>`;
      },
      mount(root) {
        const json = root.querySelector('[data-json]');
        const out = root.querySelector('[data-out]');
        root.querySelector('[data-fmt]').addEventListener('click', () => {
          try {
            out.textContent = JSON.stringify(JSON.parse(json.value), null, 2);
            out.className = 'lgk-outil__result';
          } catch (e) {
            out.textContent = 'JSON invalide : ' + e.message;
            out.className = 'lgk-outil__result lgk-outil__result--warn';
          }
        });
      },
    },

    'url-encode': {
      title: 'Encodeur URL',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Texte ou URL<textarea data-text></textarea></label>
            <div class="lgk-outil__actions">
              <button type="button" class="lgk-outil__btn" data-enc>encodeURIComponent</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-dec>decodeURIComponent</button>
            </div>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const text = root.querySelector('[data-text]');
        const out = root.querySelector('[data-out]');
        root.querySelector('[data-enc]').addEventListener('click', () => {
          out.textContent = encodeURIComponent(text.value);
        });
        root.querySelector('[data-dec]').addEventListener('click', () => {
          try {
            out.textContent = decodeURIComponent(text.value);
          } catch (e) {
            out.textContent = 'URI invalide';
          }
        });
      },
    },

    'case-convert': {
      title: 'Convertisseur de casse',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Texte<textarea data-text placeholder="mon_texte_exemple"></textarea></label>
            <div class="lgk-outil__actions">
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-up>MAJUSCULES</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-low>minuscules</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-snake>snake_case</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-kebab>kebab-case</button>
            </div>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const text = root.querySelector('[data-text]');
        const out = root.querySelector('[data-out]');
        const norm = (s) =>
          s
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-zA-Z0-9]+/g, ' ')
            .trim();
        root.querySelector('[data-up]').addEventListener('click', () => {
          out.textContent = text.value.toUpperCase();
        });
        root.querySelector('[data-low]').addEventListener('click', () => {
          out.textContent = text.value.toLowerCase();
        });
        root.querySelector('[data-snake]').addEventListener('click', () => {
          out.textContent = norm(text.value).toLowerCase().replace(/\s+/g, '_');
        });
        root.querySelector('[data-kebab]').addEventListener('click', () => {
          out.textContent = norm(text.value).toLowerCase().replace(/\s+/g, '-');
        });
      },
    },

    'aspect-ratio': {
      title: 'Calculateur résolution & ratio',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <div class="lgk-outil__row lgk-outil__row--2">
              <label>Largeur (px)<input type="number" data-w value="1920"></label>
              <label>Hauteur (px)<input type="number" data-h value="1080"></label>
            </div>
            <div class="lgk-outil__result" data-out></div>
            <p class="lgk-outil__hint">Utile pour overlays stream, bannières et assets gaming.</p>
          </div>`;
      },
      mount(root) {
        const w = root.querySelector('[data-w]');
        const h = root.querySelector('[data-h]');
        const out = root.querySelector('[data-out]');
        function gcd(a, b) {
          return b ? gcd(b, a % b) : a;
        }
        function run() {
          const W = parseInt(w.value, 10) || 1;
          const H = parseInt(h.value, 10) || 1;
          const g = gcd(W, H);
          const mp = ((W * H) / 1e6).toFixed(2);
          out.textContent = `Ratio ${W / g}:${H / g} · ${mp} MP · ${(W / H).toFixed(3)}:1`;
        }
        w.addEventListener('input', run);
        h.addEventListener('input', run);
        run();
      },
    },

    'discord-ts': {
      title: 'Timestamp Discord',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Date & heure<input type="datetime-local" data-dt></label>
            <label>Style
              <select data-style>
                <option value="f">Date courte (f)</option>
                <option value="F">Date longue (F)</option>
                <option value="R">Relatif (R)</option>
                <option value="t">Heure courte (t)</option>
              </select>
            </label>
            <div class="lgk-outil__result" data-out></div>
            <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-copy>Copier</button>
          </div>`;
      },
      mount(root) {
        const dt = root.querySelector('[data-dt]');
        const style = root.querySelector('[data-style]');
        const out = root.querySelector('[data-out]');
        const now = new Date();
        dt.value = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
        function run() {
          const ts = Math.floor(new Date(dt.value).getTime() / 1000);
          out.textContent = `<t:${ts}:${style.value}>`;
        }
        dt.addEventListener('change', run);
        style.addEventListener('change', run);
        root.querySelector('[data-copy]').addEventListener('click', () => copyText(out.textContent));
        run();
      },
    },

    pomodoro: {
      title: 'Minuteur Pomodoro',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <div class="lgk-outil__timer-display" data-display>25:00</div>
            <div class="lgk-outil__actions">
              <button type="button" class="lgk-outil__btn" data-start>Démarrer 25 min</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-pause>Pause</button>
              <button type="button" class="lgk-outil__btn lgk-outil__btn--ghost" data-reset>Reset</button>
            </div>
          </div>`;
      },
      mount(root) {
        const display = root.querySelector('[data-display]');
        let total = 25 * 60;
        let left = total;
        let timer = null;
        function fmt(s) {
          const m = Math.floor(s / 60);
          const sec = s % 60;
          return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
        }
        function tick() {
          display.textContent = fmt(left);
          if (left <= 0) {
            clearInterval(timer);
            timer = null;
            display.textContent = 'Terminé !';
          } else left--;
        }
        root.querySelector('[data-start]').addEventListener('click', () => {
          if (timer) return;
          left = total;
          timer = setInterval(tick, 1000);
          tick();
        });
        root.querySelector('[data-pause]').addEventListener('click', () => {
          clearInterval(timer);
          timer = null;
        });
        root.querySelector('[data-reset]').addEventListener('click', () => {
          clearInterval(timer);
          timer = null;
          left = total;
          display.textContent = fmt(left);
        });
      },
    },

    'fps-bitrate': {
      title: 'Estimateur bitrate stream',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <div class="lgk-outil__row lgk-outil__row--2">
              <label>Résolution
                <select data-res>
                  <option value="4500">720p60 (~4500 kbps)</option>
                  <option value="6000" selected>1080p30 (~6000 kbps)</option>
                  <option value="9000">1080p60 (~9000 kbps)</option>
                  <option value="14000">1440p60 (~14000 kbps)</option>
                </select>
              </label>
              <label>Encodeur
                <select data-enc>
                  <option value="1">x264 / NVENC</option>
                  <option value="0.85">AV1 (plus efficace)</option>
                </select>
              </label>
            </div>
            <div class="lgk-outil__result" data-out></div>
            <p class="lgk-outil__hint">Estimation indicative pour OBS / Twitch / YouTube.</p>
          </div>`;
      },
      mount(root) {
        const res = root.querySelector('[data-res]');
        const enc = root.querySelector('[data-enc]');
        const out = root.querySelector('[data-out]');
        function run() {
          const kbps = Math.round(parseFloat(res.value) * parseFloat(enc.value));
          out.textContent = `Bitrate vidéo conseillé : ~${kbps.toLocaleString('fr-FR')} kbps · Upload min. : ~${Math.ceil(kbps * 1.3 / 1000)} Mbps`;
        }
        res.addEventListener('change', run);
        enc.addEventListener('change', run);
        run();
      },
    },

    'fivem-coords': {
      title: 'Distance coordonnées FiveM',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <p class="lgk-outil__hint">Point A</p>
            <div class="lgk-outil__row lgk-outil__row--2">
              <label>X<input type="number" step="any" data-x1 value="0"></label>
              <label>Y<input type="number" step="any" data-y1 value="0"></label>
            </div>
            <p class="lgk-outil__hint">Point B</p>
            <div class="lgk-outil__row lgk-outil__row--2">
              <label>X<input type="number" step="any" data-x2 value="100"></label>
              <label>Y<input type="number" step="any" data-y2 value="200"></label>
            </div>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const fields = ['x1', 'y1', 'x2', 'y2'].map((k) => root.querySelector(`[data-${k}]`));
        const out = root.querySelector('[data-out]');
        function run() {
          const [x1, y1, x2, y2] = fields.map((f) => parseFloat(f.value) || 0);
          const d = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
          out.textContent = `Distance 2D : ${d.toFixed(2)} unités GTA`;
        }
        fields.forEach((f) => f.addEventListener('input', run));
        run();
      },
    },

    'hex-rgb': {
      title: 'Convertisseur couleur Hex ↔ RGB',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Hex<input type="text" data-hex value="#6366f1" maxlength="7"></label>
            <label>R, G, B
              <div class="lgk-outil__row lgk-outil__row--2">
                <input type="number" data-r min="0" max="255" value="99">
                <input type="number" data-g min="0" max="255" value="102">
                <input type="number" data-b min="0" max="255" value="241">
              </div>
            </label>
            <div class="lgk-outil__result" data-swatch style="min-height:3rem;border-radius:10px"></div>
          </div>`;
      },
      mount(root) {
        const hex = root.querySelector('[data-hex]');
        const r = root.querySelector('[data-r]');
        const g = root.querySelector('[data-g]');
        const b = root.querySelector('[data-b]');
        const swatch = root.querySelector('[data-swatch]');
        let lock = false;
        function toHex(n) {
          return Math.max(0, Math.min(255, n)).toString(16).padStart(2, '0');
        }
        function fromHex() {
          if (lock) return;
          lock = true;
          let h = hex.value.replace('#', '');
          if (h.length === 3) h = h.split('').map((c) => c + c).join('');
          if (h.length === 6) {
            r.value = parseInt(h.slice(0, 2), 16);
            g.value = parseInt(h.slice(2, 4), 16);
            b.value = parseInt(h.slice(4, 6), 16);
            swatch.style.background = `#${h}`;
            swatch.textContent = `rgb(${r.value}, ${g.value}, ${b.value})`;
          }
          lock = false;
        }
        function fromRgb() {
          if (lock) return;
          lock = true;
          const h = `#${toHex(+r.value)}${toHex(+g.value)}${toHex(+b.value)}`;
          hex.value = h;
          swatch.style.background = h;
          swatch.textContent = `rgb(${r.value}, ${g.value}, ${b.value})`;
          lock = false;
        }
        hex.addEventListener('input', fromHex);
        [r, g, b].forEach((inp) => inp.addEventListener('input', fromRgb));
        fromHex();
      },
    },

    'margin-profit': {
      title: 'Marge & prix de vente',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <div class="lgk-outil__row lgk-outil__row--2">
              <label>Coût d'achat HT (€)<input type="number" step="0.01" data-cost value="10"></label>
              <label>Marge souhaitée (%)<input type="number" step="1" data-margin value="40"></label>
            </div>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const cost = root.querySelector('[data-cost]');
        const margin = root.querySelector('[data-margin]');
        const out = root.querySelector('[data-out]');
        function run() {
          const c = parseFloat(cost.value) || 0;
          const m = parseFloat(margin.value) || 0;
          const sell = c * (1 + m / 100);
          const profit = sell - c;
          out.textContent = `Prix de vente HT : ${sell.toFixed(2)} € · Profit : ${profit.toFixed(2)} € · TTC (20 %) : ${(sell * 1.2).toFixed(2)} €`;
        }
        cost.addEventListener('input', run);
        margin.addEventListener('input', run);
        run();
      },
    },

    currency: {
      title: 'Convertisseur devises (indicatif)',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Montant EUR (€)<input type="number" step="0.01" data-eur value="100"></label>
            <div class="lgk-outil__result" data-out></div>
            <p class="lgk-outil__hint">Taux indicatifs — non contractuels.</p>
          </div>`;
      },
      mount(root) {
        const eur = root.querySelector('[data-eur]');
        const out = root.querySelector('[data-out]');
        eur.addEventListener('input', () => {
          const v = parseFloat(eur.value) || 0;
          const lines = Object.entries(FX).map(([k, rate]) => `${k} : ${(v * rate).toFixed(2)}`);
          out.innerHTML = lines.join('<br>');
        });
        eur.dispatchEvent(new Event('input'));
      },
    },

    lorem: {
      title: 'Générateur Lorem ipsum',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Paragraphes<input type="number" data-n value="2" min="1" max="8"></label>
            <button type="button" class="lgk-outil__btn" data-gen>Générer</button>
            <div class="lgk-outil__result" data-out style="max-height:12rem;overflow:auto"></div>
          </div>`;
      },
      mount(root) {
        const words =
          'lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua'.split(' ');
        const n = root.querySelector('[data-n]');
        const out = root.querySelector('[data-out]');
        root.querySelector('[data-gen]').addEventListener('click', () => {
          const paras = [];
          for (let p = 0; p < (parseInt(n.value, 10) || 1); p++) {
            let s = [];
            for (let i = 0; i < 40; i++) s.push(words[Math.floor(Math.random() * words.length)]);
            s[0] = s[0].charAt(0).toUpperCase() + s[0].slice(1);
            paras.push(s.join(' ') + '.');
          }
          out.textContent = paras.join('\n\n');
        });
        root.querySelector('[data-gen]').click();
      },
    },

    'px-rem': {
      title: 'Convertisseur PX → REM',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Pixels<input type="number" data-px value="16"></label>
            <label>Base (px)<input type="number" data-base value="16"></label>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const px = root.querySelector('[data-px]');
        const base = root.querySelector('[data-base]');
        const out = root.querySelector('[data-out]');
        function run() {
          const p = parseFloat(px.value) || 0;
          const b = parseFloat(base.value) || 16;
          const rem = p / b;
          out.textContent = `${p}px = ${rem.toFixed(4)}rem (base ${b}px)`;
        }
        px.addEventListener('input', run);
        base.addEventListener('input', run);
        run();
      },
    },

    'hash-sha256': {
      title: 'Hash SHA-256',
      render() {
        return `
          <div class="lgk-outil" data-tool-root>
            <label>Texte<textarea data-text placeholder="Texte à hasher"></textarea></label>
            <button type="button" class="lgk-outil__btn" data-hash>Calculer SHA-256</button>
            <div class="lgk-outil__result" data-out></div>
          </div>`;
      },
      mount(root) {
        const text = root.querySelector('[data-text]');
        const out = root.querySelector('[data-out]');
        root.querySelector('[data-hash]').addEventListener('click', async () => {
          const buf = new TextEncoder().encode(text.value);
          const hash = await crypto.subtle.digest('SHA-256', buf);
          out.textContent = Array.from(new Uint8Array(hash))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');
        });
      },
    },
  };

  window.LGK_OUTILS_TOOLS = TOOLS;

  const CAT_LABELS = {
    all: 'Tous',
    general: 'Général',
    seo: 'SEO & Web',
    dev: 'Dev',
    boutique: 'Boutique',
    pro: 'Pro',
    gaming: 'Gaming',
    fivem: 'FiveM',
    pc: 'PC & Windows',
  };

  function shopRoot(mainUrl) {
    const base = (mainUrl || '/pages/outils').replace(/\/+$/, '');
    return base.replace(/\/pages\/outils$/, '') || '';
  }

  function toolPageUrl(mainUrl, toolId) {
    return `${shopRoot(mainUrl)}/pages/outil-${toolId}`;
  }

  function guideUrl(mainUrl, toolId) {
    return `${shopRoot(mainUrl)}/blogs/outils-gratuits/guide-${toolId}`;
  }

  function hubPageUrl(mainUrl, slug) {
    return `${shopRoot(mainUrl)}/pages/${slug}`;
  }

  window.LGK_OUTILS_URLS = {
    shopRoot,
    toolPageUrl,
    guideUrl,
    hubPageUrl,
  };

  function renderCard(item, mainUrl) {
    const card = document.createElement('article');
    card.className = 'lgk-outils-hub__card';
    card.setAttribute('role', 'listitem');
    card.tabIndex = 0;
    card.dataset.toolId = item.id;
    card.dataset.category = item.cat;
    card.dataset.title = item.title;
    card.dataset.toolType = item.type || 'app';
    const tag = CAT_LABELS[item.cat] || item.cat;
    const typeLabel =
      item.type === 'link' ? ' · Lien' : item.type === 'hub' ? ' · Hub' : '';
    const pageHref = toolPageUrl(mainUrl, item.id);
    const guideHref = guideUrl(mainUrl, item.id);
    card.innerHTML = `
      <div class="lgk-outils-hub__card-top">
        <span class="lgk-outils-hub__icon" aria-hidden="true">${item.icon || '🛠️'}</span>
        <p class="lgk-outils-hub__card-title">${item.title}</p>
      </div>
      <p class="lgk-outils-hub__card-desc">${item.desc || ''}</p>
      <span class="lgk-outils-hub__card-tag">${tag}${typeLabel}</span>
      <span class="lgk-outils-hub__card-links">
        <a href="${pageHref}" class="lgk-outils-hub__card-link" data-page-link>Page</a>
        <a href="${guideHref}" class="lgk-outils-hub__card-link" data-guide-link>Guide</a>
      </span>`;
    return card;
  }

  function renderHubPanel(hubId, catalog, panel, openTool, mainUrl) {
    const hub = catalog.hubs?.[hubId];
    if (!hub) return false;
    panel.innerHTML = `
      <p class="lgk-outil__hint">${hub.intro || ''}</p>
      <div class="lgk-outils-hub__hub-links" role="list">
        ${(hub.links || [])
          .map((link) => {
            const isInternal = link.url?.startsWith('#');
            const href = isInternal
              ? toolPageUrl(mainUrl, link.url.slice(1))
              : link.url;
            const external = !isInternal && /^https?:\/\//i.test(link.url || '');
            return `
          <a class="lgk-outils-hub__hub-link" href="${href}" role="listitem"
            ${external ? 'target="_blank" rel="noopener noreferrer"' : ''}>
            <span class="lgk-outils-hub__hub-link-icon" aria-hidden="true">${link.icon || '🔗'}</span>
            <span class="lgk-outils-hub__hub-link-body">
              <span class="lgk-outils-hub__hub-link-title">${link.title}</span>
              <span class="lgk-outils-hub__hub-link-desc">${link.desc || ''}</span>
            </span>
            ${link.badge ? `<span class="lgk-outils-hub__hub-link-badge">${link.badge}</span>` : ''}
          </a>`;
          })
          .join('')}
      </div>`;
    return true;
  }

  function initHub(hub) {
    try {
      initHubCore(hub);
    } catch (err) {
      console.error('[lgk-outils-hub] init', err);
      const empty = hub.querySelector('[data-empty]');
      if (empty) {
        empty.hidden = false;
        empty.textContent = 'Erreur d’initialisation. Rechargez la page ou contactez le support.';
      }
    }
  }

  function initHubCore(hub) {
    const sectionId = hub.dataset.sectionId;
    const modal = hub.querySelector(`#lgk-outils-modal-${sectionId}`);
    if (!modal) return;
    const panel = modal.querySelector('[data-tool-panel]');
    const modalTitle = modal.querySelector('[data-modal-title]');
    const grid = hub.querySelector('[data-grid]');
    const sectionsWrap = hub.querySelector('[data-sections]');
    const filtersWrap = hub.querySelector('[data-filters]');
    const catNav = hub.querySelector('[data-cat-nav]');
    const popularWrap = hub.querySelector('[data-popular-wrap]');
    const popularGrid = hub.querySelector('[data-popular-grid]');
    const empty = hub.querySelector('[data-empty]');
    const search = hub.querySelector('[data-search]');
    const countEl = hub.querySelector('[data-count]');
    const catalogUrl = hub.dataset.catalog;
    const layout = hub.dataset.layout || 'sections';
    const categoryPage = hub.dataset.category || 'all';
    const mainUrl = hub.dataset.mainUrl || '/pages/outils';
    const tools = window.LGK_OUTILS_TOOLS || TOOLS;

    let catalog = { tools: [], categoriesMeta: {}, hubs: {}, popularIds: [] };
    let cards = [];

    function openTool(id, title) {
      const tool = tools[id];
      if (!tool) return;
      modalTitle.textContent = title || tool.title;
      panel.innerHTML = tool.render();
      if (tool.mount) tool.mount(panel);
      if (typeof modal.showModal === 'function') modal.showModal();
    }

    function openHub(hubId, title) {
      modalTitle.textContent = title || catalog.hubs[hubId]?.title || 'Hub';
      if (!renderHubPanel(hubId, catalog, panel, openTool, mainUrl)) return;
      if (typeof modal.showModal === 'function') modal.showModal();
    }

    function navigateToToolPage(card) {
      const url = toolPageUrl(mainUrl, card.dataset.toolId);
      if (url) window.location.assign(url);
    }

    function wireCard(card) {
      card.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        navigateToToolPage(card);
      });
      card.addEventListener('keydown', (e) => {
        if (e.target.closest('a')) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          navigateToToolPage(card);
        }
      });
    }

    function filterCards() {
      const cat = hub.dataset.activeFilter || 'all';
      const q = (hub.dataset.search || '').toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matchCat = cat === 'all' || card.dataset.category === cat;
        const text = (card.dataset.title + ' ' + card.textContent).toLowerCase();
        const matchQ = !q || text.includes(q);
        const show = matchCat && matchQ;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (empty) empty.hidden = visible > 0;
      if (countEl && layout !== 'sections') {
        countEl.textContent = `${visible} outil${visible > 1 ? 's' : ''}`;
      }
    }

    function buildCategoryNav(meta) {
      if (!catNav) return;
      const ordered = Object.values(meta || {}).sort((a, b) => (a.order || 0) - (b.order || 0));
      ordered.forEach((cat) => {
        const a = document.createElement('a');
        a.className = 'lgk-outils-hub__cat-pill';
        a.href = hubPageUrl(mainUrl, cat.slug);
        a.textContent = `${cat.icon || ''} ${cat.title}`.trim();
        a.dataset.catPill = cat.id;
        catNav.appendChild(a);
      });
      catNav.hidden = false;
    }

    function buildFilterButtons(meta) {
      if (!filtersWrap) return;
      const ordered = Object.values(meta || {}).sort((a, b) => (a.order || 0) - (b.order || 0));
      ordered.forEach((cat) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lgk-outils-hub__filter';
        btn.dataset.filter = cat.id;
        btn.setAttribute('role', 'tab');
        btn.textContent = `${cat.icon || ''} ${cat.title}`.trim();
        btn.addEventListener('click', () => {
          hub.dataset.activeFilter = cat.id;
          filtersWrap.querySelectorAll('[data-filter]').forEach((b) =>
            b.classList.toggle('is-active', b === btn)
          );
          filterCards();
        });
        filtersWrap.appendChild(btn);
      });
      filtersWrap.hidden = false;
      filtersWrap.querySelector('[data-filter="all"]')?.addEventListener('click', () => {
        hub.dataset.activeFilter = 'all';
        filtersWrap.querySelectorAll('[data-filter]').forEach((b) =>
          b.classList.toggle('is-active', b.dataset.filter === 'all')
        );
        filterCards();
      });
    }

    function mountFlat(list) {
      grid.hidden = false;
      if (sectionsWrap) sectionsWrap.hidden = true;
      grid.querySelectorAll('.lgk-outils-hub__card').forEach((c) => c.remove());
      cards = list.map((item) => {
        const card = renderCard(item, mainUrl);
        wireCard(card);
        grid.insertBefore(card, empty);
        return card;
      });
      if (countEl) countEl.textContent = `${list.length} outils`;
      filterCards();
    }

    function mountSections(allTools, meta) {
      if (!sectionsWrap) return mountFlat(allTools);
      grid.hidden = true;
      sectionsWrap.hidden = false;
      sectionsWrap.innerHTML = '';
      cards = [];

      const ordered = Object.values(meta || {}).sort((a, b) => (a.order || 0) - (b.order || 0));
      ordered.forEach((cat) => {
        const catTools = allTools.filter((t) => t.cat === cat.id);
        if (!catTools.length) return;

        const section = document.createElement('section');
        section.className = 'lgk-outils-hub__category';
        section.id = `outils-${cat.id}`;
        section.dataset.categorySection = cat.id;

        const head = document.createElement('div');
        head.className = 'lgk-outils-hub__category-head';
        head.innerHTML = `
          <div>
            <h2 class="lgk-outils-hub__section-title">${cat.icon || ''} ${cat.title}</h2>
            <p class="lgk-outils-hub__section-desc">${cat.intro || ''}</p>
            <p class="lgk-outils-hub__section-count">${catTools.length} outil${catTools.length > 1 ? 's' : ''} — gratuit</p>
          </div>
          <a class="lgk-outils-hub__section-more" href="${hubPageUrl(mainUrl, cat.slug)}">Voir tout →</a>`;
        section.appendChild(head);

        const catGrid = document.createElement('div');
        catGrid.className = 'lgk-outils-hub__grid';
        catGrid.setAttribute('role', 'list');

        const preview = catTools.slice(0, 8);
        preview.forEach((item) => {
          const card = renderCard(item, mainUrl);
          wireCard(card);
          catGrid.appendChild(card);
          cards.push(card);
        });

        section.appendChild(catGrid);
        sectionsWrap.appendChild(section);
      });

      if (countEl) countEl.textContent = `${allTools.length}+ outils gratuits`;
      if (empty) empty.hidden = true;
    }

    function mountPopular(allTools, popularIds) {
      if (!popularWrap || !popularGrid) return;
      const ids = popularIds || [];
      const items = ids
        .map((id) => allTools.find((t) => t.id === id))
        .filter(Boolean)
        .slice(0, 8);
      if (!items.length) return;
      popularGrid.innerHTML = '';
      items.forEach((item) => {
        const card = renderCard(item, mainUrl);
        wireCard(card);
        popularGrid.appendChild(card);
      });
      popularWrap.hidden = false;
    }

    function mountCatalog(data) {
      catalog = data;
      let list = data.tools || [];
      if (layout === 'category' && categoryPage !== 'all') {
        list = list.filter((t) => t.cat === categoryPage);
      }

      buildCategoryNav(data.categoriesMeta);
      if (layout === 'flat' || layout === 'category') {
        buildFilterButtons(data.categoriesMeta);
        if (layout === 'category') hub.dataset.activeFilter = categoryPage;
        mountFlat(list);
      } else {
        mountPopular(list, data.popularIds);
        mountSections(list, data.categoriesMeta);
      }
    }

    if (search) {
      search.addEventListener('input', () => {
        hub.dataset.search = search.value.trim();
        if (layout === 'sections' && hub.dataset.search) {
          grid.hidden = false;
          if (sectionsWrap) sectionsWrap.hidden = true;
          if (popularWrap) popularWrap.hidden = true;
          mountFlat(catalog.tools || []);
        } else if (layout === 'sections' && !hub.dataset.search) {
          mountCatalog(catalog);
        } else {
          filterCards();
        }
      });
    }

    function loadCatalog() {
      try {
        if (window.LGK_OUTILS_CATALOG && window.LGK_OUTILS_CATALOG.tools) {
          mountCatalog(window.LGK_OUTILS_CATALOG);
          return;
        }
        if (!catalogUrl) {
          if (empty) {
            empty.hidden = false;
            empty.textContent = 'Catalogue indisponible.';
          }
          return;
        }
        fetch(catalogUrl)
          .then((r) => {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then((data) => mountCatalog(data))
          .catch(() => {
            if (empty) {
              empty.hidden = false;
              empty.textContent = 'Impossible de charger le catalogue. Rechargez la page.';
            }
          });
      } catch (err) {
        console.error('[lgk-outils-hub] loadCatalog', err);
        if (empty) {
          empty.hidden = false;
          empty.textContent = 'Erreur au chargement du catalogue. Rechargez la page.';
        }
      }
    }

    loadCatalog();

    const closeBtn = modal.querySelector('[data-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => modal.close());
    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-lgk-outils]').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
